import 'css-chunk:src/components/toast/toast-component.module.scss';export default {
  "toast-container": "toast-component_toast-container__prBWG",
  "hide": "toast-component_hide__gHxZD",
  "visible": "toast-component_visible__k6xTe",
  "fullscreen": "toast-component_fullscreen__1ILll",
  "success": "toast-component_success__r0mVx",
  "icon-container": "toast-component_icon-container__ToXIh",
  "load-bar": "toast-component_load-bar__Fvb5T",
  "icon": "toast-component_icon__BlBYf",
  "info-icon": "toast-component_info-icon__yPLyu",
  "warning": "toast-component_warning__CCBml",
  "error": "toast-component_error__vhJE3",
  "information": "toast-component_information__n3xOC",
  "stock": "toast-component_stock__2J49L",
  "toast": "toast-component_toast__U4DlT",
  "toast-text": "toast-component_toast-text__KDLUf",
  "load-animation": "toast-component_load-animation__xw7Bp",
  "close-icon": "toast-component_close-icon__vh3g3"
};